module.exports = __webpack_public_path__ + "static/media/autosuggestMachine.837034a0.svg";